/**
 * Skeleton - 骨架屏组件
 */
import React from "react";
import styles from "./Skeleton.module.css";

export type SkeletonAnimation = "shimmer" | "pulse" | "none";

export interface SkeletonProps {
  /** 宽度 */
  width?: number | string;
  /** 高度 */
  height?: number | string;
  /** 圆角 */
  borderRadius?: number | string;
  /** 是否为圆形（头像场景），设置后 borderRadius 失效 */
  circle?: boolean;
  /** 动画类型，默认 shimmer */
  animation?: SkeletonAnimation;
  /** 自定义类名 */
  className?: string;
  /** 自定义内联样式，会覆盖 width / height / borderRadius */
  style?: React.CSSProperties;
  /**
   * 覆盖模式：自动 position: absolute + inset: 0。
   * 需要父容器具备 position: relative / absolute / fixed / sticky。
   */
  overlay?: boolean;
}

const toSize = (value?: number | string) => {
  if (value === undefined || value === null) return undefined;
  return typeof value === "number" ? `${value}px` : value;
};

const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  borderRadius,
  circle = false,
  animation = "shimmer",
  className,
  style,
  overlay = false,
}) => {
  const mergedStyle: React.CSSProperties = {
    ...(overlay ? { position: "absolute", inset: 0 } : {}),
    width: toSize(width),
    height: toSize(height),
    borderRadius: circle ? undefined : toSize(borderRadius),
    ...style,
  };

  const animationClass =
    animation === "shimmer"
      ? styles.skeletonShimmer
      : animation === "pulse"
        ? styles.skeletonPulse
        : "";

  const classes = [
    styles.skeleton,
    circle ? styles.skeletonCircle : "",
    animationClass,
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={classes} style={mergedStyle} aria-hidden />;
};

export { Skeleton };
